import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import elementZh from 'element-ui/lib/locale/lang/zh-CN';
import elementEn from 'element-ui/lib/locale/lang/en';
import zh from './lang/zh';
import en from './lang/en';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  fallbackLocale: 'zh',
  silentTranslationWarn: true,
  messages: {
    zh: { ...zh, ...elementZh },
    en: { ...en, ...elementEn }
  }
});

// Element UI 跟随 vue-i18n 切换
ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;
